import { useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import FeatureSettingsConsentsModal from 'src/components/FeatureSettingsConsentsModal/FeatureSettingsConsentsModal';
import { useClientControlPopup } from 'src/hooks/useClientControlPopup';
import useIsOpenModal from 'src/hooks/useIsOpenModal';
import useLogin from 'src/hooks/useLogin';
import { featureSettingsPopupsAtom, getFeatureSettingsPopupAtom } from 'src/stores/auth/atoms';
import { UserSettingType } from 'src/stores/user/types';
import { ModalType } from 'src/types/Modal';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useFeatureSettingsPopupModal: OrderedModalHookType = modalPropsPromise => {
  const [featureSettingsPopups, setFeatureSettingsPopups] = useAtom(featureSettingsPopupsAtom);
  const getFeatureSettingsPopup = useSetAtom(getFeatureSettingsPopupAtom);
  const {
    isLogin
  } = useLogin();
  const {
    setDisplayTime,
    setIsResolved,
    shouldDisplayPopup
  } = useClientControlPopup();
  const isGuidelineModalOpened = useIsOpenModal(ModalType.REGISTER_GUIDELINE);
  useEffect(() => {
    if (!isLogin) return;
    if (featureSettingsPopups === undefined) {
      getFeatureSettingsPopup();
      return;
    }

    // 가이드라인 모달에서 동의받는 featureSettings 팝업도 존재하므로, 가이드라인 모달이 열려있으면 promise resolve 하지 않음
    if (isGuidelineModalOpened) return;
    const handleClose = (type: UserSettingType) => {
      setIsResolved(type);
      setFeatureSettingsPopups(prev => prev ? prev.slice(1) : []);
    };
    modalPropsPromise?.resolve(featureSettingsPopups.filter(featureSettingsPopup => shouldDisplayPopup(featureSettingsPopup.type, featureSettingsPopup.displayIntervalInMinutes)).map(featureSettingsPopup => {
      return {
        modalProps: {
          key: ModalType.FEATURE_SETTINGS_CONSENTS,
          component: () => <FeatureSettingsConsentsModal popup={featureSettingsPopup} onClose={() => handleClose(featureSettingsPopup.type)} onDisplay={() => setDisplayTime(featureSettingsPopup.type)} />
        }
      };
    }));
  }, [getFeatureSettingsPopup, modalPropsPromise, featureSettingsPopups, isLogin, shouldDisplayPopup, setIsResolved, setDisplayTime, setFeatureSettingsPopups, isGuidelineModalOpened]);
};
export default withLoginUserModalPromise(useFeatureSettingsPopupModal);